import { Separator } from '@/components/ui/separator';

const metrics = [
  { value: '120+', label: 'Organisations' },
  { value: '8,400', label: 'Tenders reviewed' },
  { value: '62%', label: 'Time saved per bid' },
  { value: '34%', label: 'Win rate increase' },
];

export default function SocialProof() {
  return (
    <section
      id="proof"
      data-testid="social-proof-section"
      className="py-5 md:py-15 scroll-mt-24"
    >
      <div className="py-5 md:py-15">
        <div className="section-container">
          <p data-animate className="kicker text-center mb-10">Trusted by procurement teams</p>
          <div
            data-animate
            style={{ transitionDelay: '80ms' }}
            className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12"
          >
            {metrics.map((m, i) => (
              <div
                key={m.label}
                data-testid={`social-proof-stat-${i}`}
                className="text-center"
              >
                <p className="font-display text-[40px] md:text-[46px] tracking-tight text-primary">
                  {m.value}
                </p>
                <p className="text-sm text-muted-foreground mt-1">{m.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
